import queryString from "query-string";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

import Form from "./group details component/Form";
import {
  groupObject,
  objectFromResponseData,
} from "./group details component/groupObject";
import { useAxios, useComponent } from "../../hooks";

export default function GroupDetails() {
  const axios = useAxios();
  const { groupID } = useParams();
  const { loader } = useComponent();
  const [editState, setEditState] = useState(true);
  const [formData, setFormData] = useState(groupObject);

  const mode = queryString.parse(window.location.search).mode;

  useEffect(() => {
    loader.start();
    if (groupID) {
      setEditState(false);
    }

    if (mode === "edit") {
      setEditState(true);
    }

    if (groupID) {
      axios({
        url: "/get/fieldGroup/" + groupID,
      }).then((response) => {
        if (response.status) {
          setFormData(objectFromResponseData(response.data));
        }
      });
    } else {
      loader.stop();
    }
  }, [groupID, mode, axios, loader]);

  return (
    <Form
      editState={editState}
      setEditState={setEditState}
      formData={formData}
      setFormData={setFormData}
    />
  );
}
